var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yd-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "60%",
            "before-close": _vm.handleClose,
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("操作日志"),
          ]),
          _c(
            "div",
            [
              _c("LogInfo", {
                attrs: {
                  visible: _vm.dialogVisible,
                  flightPlanId: _vm.linkId,
                  type: 13,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("关 闭"),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }